// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsentPreview_root__1GyEM","description":"PatientConsentPreview_description__LSvNJ"};